import React from 'react'
import {
  PhoneNumberInput,
  VerifyPhoneNumberFailureFragment,
  VerifyPhoneNumberFailureType,
} from 'src/graphql/generated/graphql'
import { getFormattedNumber } from 'src/onboarding/components/PhoneNumberVerification'
import {
  Anchor,
  Button,
  Flex,
  Icon,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'

const IncorrectCode = (props: {
  phoneNumber: PhoneNumberInput
  failure?: VerifyPhoneNumberFailureFragment
  getNewCode: (phoneNumber?: PhoneNumberInput) => void
  tryAgain: () => void
}) => {
  const { getNewCode, tryAgain, phoneNumber, failure } = props

  const formattedNumber = getFormattedNumber(
    phoneNumber.countryIsoCode,
    phoneNumber.nationalNumber,
  )

  const content =
    failure?.failureType === VerifyPhoneNumberFailureType.CodeExpired ? (
      <>
        <Spacer space="x3" />
        <Text type="subtitle" weight="bold">
          Code Expired
        </Text>
        <Spacer space="x2" />
        <Text type="caption" alignment={'center'}>
          The code you entered is expired
        </Text>
      </>
    ) : failure?.failureType ===
      VerifyPhoneNumberFailureType.TooManyAttempts ? (
      <>
        <Spacer space="x3" />
        <Text type="subtitle" weight="bold">
          Too Many Attempts
        </Text>
        <Spacer space="x2" />
        <Text type="caption" alignment={'center'}>
          There has been to many attempts for the number:
          <Text type={'subtitle'} alignment="center">
            <b>{` ${formattedNumber} `}</b>
          </Text>
        </Text>
        <Spacer space="x3" />
        <Text type="caption" alignment="left">
          For further assistance, contact the Customer Success team at
          <b> (801) 463-3800 </b>
          to resolve this issue.
        </Text>
      </>
    ) : (
      <>
        <Spacer space="x3" />
        <Text type="subtitle" weight="bold">
          Code Not Found
        </Text>
        <Spacer space="x2" />
        <Text type="caption" alignment={'center'}>
          Looks like the code you entered does not match the token we sent to:
          <Text type={'subtitle'} alignment="center">
            <b>{` ${formattedNumber} `}</b>
          </Text>
        </Text>
      </>
    )

  const buttons =
    failure?.failureType === VerifyPhoneNumberFailureType.CodeExpired ? (
      <>
        <Button
          title={'Get a new code'}
          onClick={() => getNewCode(undefined)}
          outlined={true}
          type="shadow"
          hover={true}
        />
      </>
    ) : failure?.failureType ===
      VerifyPhoneNumberFailureType.TooManyAttempts ? (
      <></>
    ) : (
      <>
        <Button
          title={'Get a new code'}
          onClick={() => getNewCode(undefined)}
          outlined={true}
          type="shadow"
          hover={true}
        />
        <Spacer space="x2" />
        <Anchor
          title="Try my code again"
          size="small"
          onClick={tryAgain}
          isDecorated={true}
        />
      </>
    )

  return (
    <div>
      <Spacer space="x4" />
      <Flex
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
      >
        <Icon name="exclamation" size="xLarge" primaryColor="danger" />
        {content}
      </Flex>
      <Spacer space="x2" />
      <Flex justifyContent="center" flexDirection="column" alignItems="center">
        {buttons}
      </Flex>
    </div>
  )
}

export default IncorrectCode
